import type { ReactNode } from "react";

type PublicPageShellProps = {
  eyebrow?: string;
  pill?: ReactNode;
  title: string;
  lead: ReactNode;
  leadMuted?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

export function PublicPageShell({
  eyebrow,
  pill,
  title,
  lead,
  leadMuted,
  actions,
  children,
}: PublicPageShellProps) {
  return (
    <div className="pub-page">
      <header className="pub-page-top">
        {pill}
        {eyebrow ? <p className="pub-page-eyebrow">{eyebrow}</p> : null}
        <h1 className="pub-page-title">{title}</h1>
        <p className="pub-page-lead">
          {lead}
          {leadMuted ? <span className="pub-page-lead-muted">{leadMuted}</span> : null}
        </p>
        {actions ? <div className="pub-page-actions">{actions}</div> : null}
      </header>
      <div className="pub-page-body">{children}</div>
    </div>
  );
}
